import AccountIcon from 'src/assets/svg/settings-acct-icon'
import AccountIconD3 from 'src/assets/svg/settings-acct-icon-d3'
import BeneficiaryIcon from 'src/assets/svg/settings-beneficiary-icon'
import BeneficiaryIconD3 from 'src/assets/svg/settings-beneficiary-icon-d3'
import TxLimitIcon from 'src/assets/svg/settings-tx-limit-icon'
import TxLimitIconD3 from 'src/assets/svg/settings-tx-limit-icon-d3'
import ScheduledTxIcon from 'src/assets/svg/settings-scheduled-tx-icon'
import ScheduledTxIconD3 from 'src/assets/svg/settings-scheduled-tx-icon-d3'
import UpgradeAcctIcon from 'src/assets/svg/settings-acct-upgrade-icon'
import UpgradeAcctIconD3 from 'src/assets/svg/settings-acct-upgrade-icon-d3'
import PinIcon from 'src/assets/svg/settings-pin-icon'
import PinIconD3 from 'src/assets/svg/settings-pin-icon-d3'
import EmailIcon from 'src/assets/svg/support.email.icon'
import EmailIconD3 from 'src/assets/svg/support.email.icon.d3'
import PhoneIcon from 'src/assets/svg/support.phone.icon'
import PhoneIconD3 from 'src/assets/svg/support.phone.icon.d3'
import ChatIcon from 'src/assets/svg/support.chat.icon'
import ChatIconD3 from 'src/assets/svg/support.chat.icon.d3'
import MtnLogo from 'src/assets/img/mtn-logo.svg'
import AirtelLogo from 'src/assets/img/airtel-logo.svg'
import GloLogo from 'src/assets/img/glo-logo.svg'
import EtisalatLogo from 'src/assets/img/etisalat-logo.svg'
import FaqIcon from 'src/assets/svg/faq-icon'
import FaqIconD3 from 'src/assets/svg/faq-icon-d3'

let isLive = process.env.REACT_APP_ENVIRONMENT === 'production' ;
console.log({environment: process.env.REACT_APP_ENVIRONMENT})

export const images = {
    
}

//http://52.170.1.4:12000/api
//https://52.170.1.4/api
//https://ib-proxy.vercel.app/api
//https://stagingapi.qoreonline.com/api

export const url = {
    BASE_URL: isLive ? 'https://api.qoreonline.com/api' : 'https://stagingapi.qore.build/api'
}

export const initialState = {
   
}

export const appSettings = {
    SESSION_EXPIRATION_MSG: 'Your session has expired. Please login afresh and try again.',
    LONG_DURATION_STATEMENT_MSG: 'Your account miniStatement is being fetched and will be sent to your registered email.',
    INACTIVITY_TIME: 1000 * 60 * 25,
    SESSION_EXPIRATION_LENGTH: 25,
}

export const institutionConfig = {
    cardinalStone: {
        INACTIVITY_TIME: 1000 * 60 * 2,
        SESSION_EXPIRATION_LENGTH: 3,
    }
}

export const accountSettings = [
    {
        name: 'My Account',
        description: 'Control your account settings effortlessly.',
        view: 'my-account',
        icon: {
            d1: <AccountIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <AccountIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    {
        name: 'Account Officer',
        description: 'Get expert guidance from your dedicated account officer.',
        view: 'account-officer',
        icon: {
            d1: <AccountIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <AccountIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    {
        name: 'Manage Beneficiaries',
        description: 'Add, edit, or remove beneficiaries with ease.',
        view: 'beneficiaries',
        icon: {
            d1: <BeneficiaryIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <BeneficiaryIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    {
        name: 'Manage Transaction Limit',
        description: 'Add, edit, or remove beneficiaries with ease.',
        view: 'tx-limit',
        icon: {
            d1: <TxLimitIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <TxLimitIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    {
        name: 'Manage Scheduled Transactions',
        description: 'Efficiently manage your upcoming transactions in one place.',
        view: 'scheduled-tx',
        icon: {
            d1: <ScheduledTxIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <ScheduledTxIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    // {
    //     name: 'Hide Balance',
    //     description: 'Lorem Ipsum',
    //     view: 'hide-balance',
    //     icon: HideBalanceIcon
    // },
    {
        name: 'Upgrade Account',
        description: 'Elevate your experience with an upgraded account status.',
        view: 'account-upgrade',
        icon: {
            d1: <UpgradeAcctIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <UpgradeAcctIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    },
    {
        name: 'Delete Account',
        description: 'Delete your active account',
        view: 'account-deletion',
        icon: {
            d1: <UpgradeAcctIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />,
            d3: <UpgradeAcctIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
        }
    }
]

export const authSettings = [
    // {
    //     name: 'Setup Panic PIN',
    //     description: 'Set up a secure Panic PIN for quick access to emergency features.',
    //     view: 'panic-pin',
    //     icon: {
    //         d1: <PinIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
    //         d3: <PinIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
    //     }
    // },
    // {
    //     name: 'Change Login Method',
    //     description: 'Lorem Ipsum',
    //     view: 'login-method-change',
    //     icon: LoginMethodIcon
    // },
    {
        name: 'Forgot PIN',
        description: 'Recover your PIN quickly and easily with our password reset option.',
        view: 'forgot-pin',
        icon: {
            d1: <PinIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <PinIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    },
    {
        name: 'Change PIN',
        description: 'Easily modify your PIN for enhanced account protection.',
        view: 'change-pin',
        icon: {
            d1: <PinIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <PinIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    },
    {
        name: 'Change Password',
        description: 'Change your password effortlessly to ensure account safety.',
        view: 'change-password',
        icon: {
            d1: <PinIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <PinIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    }
]

export const supportOptions = [
    {
        name: 'Contact by Email',
        description: 'Contact our customer support team directly through email for prompt assistance.',
        view: 'contact-by-email',
        icon: {
            d1: <EmailIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <EmailIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    },
    {
        name: 'Contact by Phone',
        description: 'Get real-time help from our friendly support team by giving us a call.',
        view: 'contact-by-phone',
        icon: {
            d1: <PhoneIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <PhoneIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    },
    {
        name: 'Realtime Chat',
        description: 'Engage in live chat with our knowledgeable support agents to resolve your queries instantly.',
        view: 'realtime-chat',
        icon: {
            d1: <ChatIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3: <ChatIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
        }
    },
    {
        name: 'Frequently Asked Questions',
        description: 'Get quick answers to common questions and guidance on using our platform.',
        view: 'faq',
        icon: {
            d1:<FaqIcon className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />,
            d3:<FaqIconD3 className='icon-component' style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
    }
    }
]

export const onboardingAdds = [
    {
        title: 'Save Money',
        body: `Reach your financial goals with Qore's smart savings feature. Set aside money automatically and watch your savings grow.`
    },
    {
        title: 'Invest',
        body: `Reach your financial goals with Qore's smart savings feature. Set aside money automatically and watch your savings grow.`
    },
    {
        title: 'Take Loan',
        body: `Reach your financial goals with Qore's smart savings feature. Set aside money automatically and watch your savings grow.`
    },
    {
        title: 'Expense Tracking',
        body: `Reach your financial goals with Qore's smart savings feature. Set aside money automatically and watch your savings grow.`
    }
]

export const airtimeNetworks = [
    {
        name: 'MTN',
        img: MtnLogo,
        bgColor: '#FFCA00'
    },
    {
        name: 'AIRTEL',
        img: AirtelLogo,
        bgColor: '#FFFFFF'
    },
    {
        name: 'GLO',
        img: GloLogo,
        bgColor: '#FFFFFF'
    },
    {
        name: 'ETISALAT',
        img: EtisalatLogo,
        bgColor: '#F6F6F6'
    }
]

export const expenseCategories = [
    'Groceries',
    'Health',
    'House',
    'Investment',
    'Savings',
    'Self Care',
    'Shopping',
    'Sports',
    'Transfers',
    'Transport',
    'Travels',
    'Bills and Utilities',
    'Charity',
    'Eating out',
    'Education',
    'Entertainment',
    'Family & Friends',
    'Fitness and Wellness',
    'Food',
    'General',
    'Others'
]

// export const colors = {
//     '#0D968F': '#0000FF', // primary 1
//     "#0EA59D": '#0000FF', // Primary 1
//     '#1A2C37': '#1A2C37', // primary 2
//     '#0A756F': '#0000FF', // primary 1
//     '#69BBBA': helpers.convertHexToRGBA('#0000FF', 0.5), // primary 1
//     '#5EC3BD': helpers.convertHexToRGBA('#0000FF', 0.6), // primary 1
//     '#E7F6F5': helpers.convertHexToRGBA('#0000FF', 0.1), // secondary 1
//     '#B4E3E1': helpers.convertHexToRGBA('#0000FF', 0.2), // secondary 2
//     '#C9F3F0': helpers.convertHexToRGBA('#0000FF', 0.2), // secondary 2
//     '#E1FFFD': helpers.convertHexToRGBA('#0000FF', 0.1), // secondary 1
//     '#25C5BC': '#0000FF', // primary 1,
//     '#0D5B57': '#0000FF', // primary 1,
//     '#0E4915': '#0000FF', // primary 1,
//     '#3AAF4B': '#0000FF', // primary 1,
//     '#BEE6E3': helpers.convertHexToRGBA('#0000FF', 0.2), // secondary 2
//     '#219993': helpers.convertHexToRGBA('#0000FF', 0.2), // secondary 2
//     'rgba(26,44,55, 0.95)': helpers.convertHexToRGBA('#1A2C37', 0.95), // secondary 1 
// }

export const colors = {
    '#0D968F': '#0D968F', // primary 1
    "#0EA59D": '#0EA59D', // Primary 1
    '#1A2C37': '#1A2C37', // primary 2
    '#0A756F': '#0A756F', // primary 1
    '#69BBBA': '#69BBBA', // primary 1
    '#5EC3BD': '#5EC3BD', // primary 1
    '#E7F6F5': '#E7F6F5', // secondary 1
    '#B4E3E1': '#B4E3E1', // secondary 2
    '#C9F3F0': '#C9F3F0', // secondary 2
    '#E1FFFD': '#E1FFFD', // secondary 1
    '#25C5BC': '#25C5BC', // primary 1,
    '#0D5B57': '#0D5B57', // primary 1,
    '#0E4915': '#0E4915', // primary 1,
    '#3AAF4B': '#3AAF4B', // primary 1,
    '#BEE6E3': '#BEE6E3', // secondary 2
    '#219993': '#219993', // secondary 2
    'rgba(26,44,55, 0.95)': 'rgba(26,44,55, 0.95)' // primary 2
}

export const billTypes = {
    "1": 'Utility Bills'
}

export const IDTypes = {
    "0": "Driver's License",
    "2": "National ID / NIN Slip",
    "3": 'BVN'
}